import React from "react";
import AvailableCountries from "./AvailableCountries";
import CurrencySelection from "./CurrencySelection";

function Home(props) {
  const { homeRef, sendRef, onScroll } = props;

  return (
    <header
      ref={homeRef}
      onScroll={onScroll}
      className="position-relative w-100 pt-80"
      style={{ minHeight: "800px" }}
    >
      <div className="position-absolute start-0 top-0 w-100 full-height main-hero linear-gradient-primary-bg z-index-1"></div>
      <div className="container">
        <div ref={sendRef} className="max-width-80p mx-auto header-margin">
          <h1 className="fs-52 text-dark text-center h1-txt-shadow">
            <span className="">Send Money to your </span>
            <span className="">loved ones </span>
            <span className="">with confidence</span>
          </h1>
        </div>
        <div className="max-width-65p mx-auto pt-3">
          <CurrencySelection />
        </div>
      </div>
      <AvailableCountries />
    </header>
  );
}

export default Home;
